import React from "react";
import { Link } from "react-router-dom";
import FadeIn from "../components/FadeIn";
import { IMAGES, DESTINATIONS } from "../lib/content";

const Destinations = () => {
  return (
    <main className="pt-28 md:pt-36" data-testid="destinations-page">
      {/* Intro */}
      <section className="py-20 md:py-28 border-b border-white/5">
        <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <FadeIn>
              <div className="overline">Destinations</div>
              <h1 className="mt-5 font-serif text-5xl md:text-7xl text-bone tracking-tight leading-[1.02]">
                Places,<br /><span className="italic text-gold">selected with care.</span>
              </h1>
            </FadeIn>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <FadeIn delay={140}>
              <p className="text-bone/65 font-light text-lg leading-relaxed max-w-lg">
                Japan is vast. The Japan we design is quiet, precise, and felt.
                Each destination below is a chapter — chosen for what it offers privately, not what it promises publicly.
              </p>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* Destination rows, alternating */}
      {DESTINATIONS.map((d, i) => {
        const reverse = i % 2 === 1;
        return (
          <section key={d.slug} className="py-20 md:py-28 border-b border-white/5" data-testid={`destination-row-${d.slug}`}>
            <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
              <FadeIn className={`md:col-span-7 ${reverse ? "md:order-2" : ""}`}>
                <div className="relative overflow-hidden h-[420px] md:h-[560px] group">
                  <img
                    src={IMAGES.destinations[d.image]}
                    alt={d.name}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[2000ms] ease-out group-hover:scale-[1.04]"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                </div>
              </FadeIn>

              <FadeIn delay={120} className={`md:col-span-5 ${reverse ? "md:order-1 md:pr-8" : "md:pl-4"}`}>
                <div className="overline mb-5">{String(i + 1).padStart(2, "0")} — {d.tag}</div>
                <h2 className="font-serif text-5xl md:text-6xl text-bone tracking-tight leading-[1.05]">{d.name}</h2>
                <div className="mt-5 rule" />
                <p className="mt-8 italic text-bone/75 text-xl font-light">{d.short}</p>
                <p className="mt-6 text-bone/60 font-light leading-relaxed">{d.long}</p>
              </FadeIn>
            </div>
          </section>
        );
      })}

      {/* Closing CTA */}
      <section className="py-32 md:py-44">
        <div className="container-editorial text-center max-w-3xl mx-auto">
          <FadeIn>
            <h2 className="font-serif text-4xl md:text-6xl text-bone tracking-tight leading-[1.05]">
              Not everything is listed.<br />
              <span className="italic text-gold">Each journey is designed individually.</span>
            </h2>
          </FadeIn>
          <FadeIn delay={180}>
            <div className="mt-12">
              <Link
                to="/plan"
                className="inline-flex items-center gap-4 bg-gold text-ink px-10 py-5 text-[12px] tracking-[0.28em] uppercase font-medium hover:bg-gold-light transition-colors duration-500"
                data-testid="destinations-cta"
              >
                Plan Your Journey
                <span className="w-8 h-px bg-ink/60" />
              </Link>
            </div>
          </FadeIn>
        </div>
      </section>
    </main>
  );
};

export default Destinations;
